export default __webpack_public_path__ + "static/media/Hop_dark.74e64541.svg";